<template>
  <div>
    <generic-modal
      v-if="showLocationAccessBlockedModal"
      @close="closeModalM()"
      :height="menuModalDim.height"
      :width="menuModalDim.width"
      :modalClass="menuModalDim.modalClass"
      :zIndex="9999"
    >
      <template v-slot:header>
        <div></div>
        <!-- <i @click="closeModalM()" class="jfi-cross"></i> -->
      </template>
      <template v-slot:body>
        <div class="">
          <p class="fs-14 lh20">
            Sorry! You have blocked location access. Please type and search your
            location.
          </p>
          <br />
          <p class="fs-14 lh20">
            To allow location access please go to your browser settings
          </p>
          <br />
          <button class="btn medium fr" @click="closeModalM(false)">OK</button>
          <br />
          <br />
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
// import { VWO_HOMEPAGE_EXPERIMENT } from "../config/vwoKeys";
import { shouldHideCompleteLocationFlow } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import { setEvents } from "../helpers/analyticsEvents";
export default {
  name: "LocationAccessBlockedMessage",

  components: {
    GenericModal,
  },

  data() {
    return {
      menuModalDim: {
        width: "270px",
        height: "fit-content",
        modalClass: "",
      },
    };
  },

  mounted() {},

  computed: {
    showLocationAccessBlockedModal() {
      let showLocationAccessBlocked =
        this.$store.state.Location.showLocationAccessBlockedModal;
      if (showLocationAccessBlocked) {
        document.body.classList.add("body-stop-scroll-mobile");
      }
      return showLocationAccessBlocked;
    },
    // vwoVariant() {
    //   let exp = this.$store.state.Config.vwoExperiments;
    //   return exp?.[VWO_HOMEPAGE_EXPERIMENT];
    // },
  },

  methods: {
    closeModalM(choice) {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL,
        false
      );
      if (!shouldHideCompleteLocationFlow) {
        this.$store.dispatch(keyMapsAction.GOOGLE_GEO_LOCATION_API, {});
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_LOCATION_LOADING, false);
      }
      document.body.classList.remove("body-stop-scroll-mobile");
      let action =
        choice === undefined ? "gps off pop-up-dismissed" : "gps off pop-up-ok";
    },
  },
};
</script>

<style scoped></style>
